import PropTypes from "prop-types"
import Panel from "../panel"
import { numberFormatter } from "helpers/formatters/numbers"

import { Row } from "../rows"

function ScorecardDecompositionSummary({ originalRiskDecomposition, rebalancedRiskDecomposition }) {
  return <Panel fixed>
    <Row
      id="specific"
      label="Specific (%)"
      original={originalRiskDecomposition.specific * 100}
      rebalanced={rebalancedRiskDecomposition.specific * 100}
      delta={(rebalancedRiskDecomposition.specific - originalRiskDecomposition.specific) * 100}
      formatter={numberFormatter}
      fixed
    />
    <Row
      id="factors"
      label="Factor (%)"
      original={originalRiskDecomposition.factorsTotal * 100}
      rebalanced={rebalancedRiskDecomposition.factorsTotal * 100}
      delta={(rebalancedRiskDecomposition.factorsTotal - originalRiskDecomposition.factorsTotal) * 100}
      formatter={numberFormatter}
      fixed
    />
  </Panel>
}

ScorecardDecompositionSummary.propTypes = {
  originalRiskDecomposition: PropTypes.object.isRequired,
  rebalancedRiskDecomposition: PropTypes.object.isRequired,
}

export default ScorecardDecompositionSummary
